export default __webpack_public_path__ + "static/media/Success.6b62789d.gif";